<button matIconButton
    [matBadge]="filterCount()" 
    [matBadgeHidden]="filterCount() === 0"
    matBadgeColor="primary"
    [matTooltip]="tooltipText()"
    [class]="{ 'filter-active': isActive() }"
    [style]="isActive() ? { color: '#1976d2' } : {}"
    (click)="openFilterDialog()">
    <mat-icon>{{ isActive() ? 'filter_alt' : 'filter_list' }}</mat-icon>
</button>